module.exports = __webpack_public_path__ + "media/images/flags/1x1/rwa-0cef09c105fdff12d10b6621bc68a529.svg";